import type { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useModalStyles = makeStyles((theme: Theme) =>
	createStyles({
		checkbox: {
			userSelect: "none",
		},
		modalBody: {},
		title: {
			fontSize: 15,
		},
		chip: {
			margin: 2,
		},
		errorLabel: {
			fontSize: 12,
			color: "#F44336",
		},
	}),
);
